import { Component } from "@angular/core";
import { IHeaderAngularComp } from "ag-grid-angular";
import { IHeaderParams } from "ag-grid-community";

@Component({
  selector: "ag-grid-add-row-header",
  template: ` <a class="circle circle-add" title="Add new item" (click)="addRow()">
    <em class="material-icons-outlined">create</em>
  </a>`,
  standalone: false,
})
export class AddRowHeader implements IHeaderAngularComp {
  private params: any;
  selectColumn: string;

  agInit(params: any): void {
    this.params = params;
    this.selectColumn = params.selectColumn ? params.selectColumn : "active";
  }

  addRow() {
    if (this.params.context.parent.gridApi.getEditingCells().length == 0) {
      this.params.context.parent.addNew(this.selectColumn);
    }
  }
  refresh(params: IHeaderParams): boolean {
    return false;
  }
}
